import { css } from "@emotion/css"

type Props = {
  color: string
  size: number
}

const Circle = ({ color, size }: Props) => {
  const style = css`
    display: inline-block;
    width: ${size}px;
    height: ${size}px;
    background: ${color};
    border-radius: ${size}px;
  `

  return <span className={style} />
}

export default Circle
